import { AfterContentInit, ChangeDetectorRef, Component, ContentChild, ContentChildren, QueryList, ViewChild, ViewEncapsulation } from '@angular/core';
import { SideDrawerComponent } from './side-drawer/side-drawer.component';
import { MatDrawer } from '@angular/material/sidenav';

@Component({
    selector: 'tt-side-drawer-container',
    templateUrl: './side-drawer-container.component.html',
    styleUrls: ['./side-drawer-container.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class SideDrawerContainerComponent implements AfterContentInit {
    @ViewChild('startMatDrawer')
    public startMatDrawer?: MatDrawer;

    @ViewChild('endMatDrawer')
    public endMatDrawer?: MatDrawer;

    @ContentChildren(SideDrawerComponent, { descendants: true })
    public drawers!: QueryList<SideDrawerComponent>;

    public startDrawer?: SideDrawerComponent;

    public endDrawer?: SideDrawerComponent;

    constructor() {}

    ngAfterContentInit(): void {
        this.startDrawer = this.drawers.find((drawer) => drawer.ttPosition !== 'end');
        this.endDrawer = this.drawers.find((drawer) => drawer.ttPosition === 'end');

        setTimeout(() => {
            if (!!this.startDrawer && !!this.startMatDrawer) {
                this.startDrawer.setMatDrawerRef(this.startMatDrawer);
            }

            if (!!this.endDrawer && !!this.endMatDrawer) {
                this.endDrawer.setMatDrawerRef(this.endMatDrawer);
            }
        });
    }
}
